export enum OfferMerchandiseTypeEnum {
  CONDITIONED = 'CONDITIONED',
  UNCONDITIONED = 'UNCONDITIONED',
  QUOTATION = 'QUOTATION',
}
